import React from "react";
import { useLocation } from "wouter";
import { Divider, NavLink, AppShell, ScrollArea } from "@mantine/core";
import {
  IconKey,
  IconLogout,
  IconPhotoAi,
  IconNews,
  IconSlideshow,
  IconPhotoCog,
  IconUsers,
  IconJson,
  IconUser,
  IconBellDollar,
  IconCameraCog,
  IconPolaroid,
  IconPhotoBolt,
  IconPhotoDollar,
} from "@tabler/icons-react";
import { useStore } from "./store";
import mixpanel from "mixpanel-browser";

export default function Navbar({ toggle }) {
  const [location, setLocation] = useLocation();
  const profile = useStore((state) => state.profile);
  const plugins = useStore((state) => state.pluginData);
  const authToken = useStore((state) => state.authToken);
  const setAuthToken = useStore((state) => state.setAuthToken);
  const logoutStore = useStore((state) => state.logout);

  function AibNavLink(item) {
    return (
      <NavLink
        label={item.label}
        active={location.startsWith(item.link)}
        key={item.label}
        // color={item.plugin ? "purple" : "myColor"}
        // variant={item.plugin ? "light" : "light"}
        leftSection={item.icon && <item.icon stroke={1.5} />}
        rightSection={item.rightSection}
        disabled={item.disabled}
        onClick={(event) => {
          event.preventDefault();
          item.onClick ? item.onClick() : setLocation(item.link);
          toggle();
        }}
      />
    );
  }

  return (
    <>
      <AppShell.Section component={ScrollArea}>
        {/* <AibNavLink label="Home" link="/home" icon={IconHome} /> */}
        {authToken && (
          <>
            <AibNavLink
              label="My Gallery"
              link="/gallery"
              icon={IconPolaroid}
              disabled={profile?.plan === "Free"}
            />
            <AibNavLink
              disabled={profile?.plan === "Free"}
              label="Generate"
              link="/generate"
              icon={IconPhotoAi}
            />
            <AibNavLink
              label="Models"
              link="/training-datasets"
              icon={IconPhotoBolt}
              disabled={profile?.plan === "Free"}
            />
            <AibNavLink label="Profile" link="/profile" icon={IconUser} />
            <AibNavLink
              label="Credits"
              link="/payment/prepaid"
              icon={IconPhotoDollar}
            />
            <AibNavLink
              label="Plans"
              link="/payment/plans"
              icon={IconBellDollar}
            />
          </>
        )}

        {profile?.role === "Admin" ? (
          <>
            <Divider />
            <AibNavLink
              label="MOD Gallery"
              link="/mod/gallery"
              icon={IconSlideshow}
            />
            <AibNavLink
              label="Styles"
              link="/admin/styles"
              icon={IconPhotoCog}
            />
            <AibNavLink
              label="Plugins"
              link="/admin/plugins"
              icon={IconPhotoCog}
            />
            <AibNavLink label="Users" link="/admin/users" icon={IconUsers} />
            {/* <AibNavLink
              label="MOD Gen"
              link="/mod/generator"
              icon={IconPhotoCog}
            />
            <AibNavLink
              label="Sampling"
              link="/admin/samplingruns"
              icon={IconPhotoCog}
            /> */}
            <AibNavLink label="Jobs" link="/admin/jobs" icon={IconJson} />
          </>
        ) : null}
        <Divider />

        <AibNavLink label="Contact" link="/contact" icon={IconNews} />
        {/* <AibNavLink label="Tips & Tricks" link="/tips" icon={IconBulb} /> */}
      </AppShell.Section>
      <AppShell.Section grow component={ScrollArea}>
        {authToken && (
          <AibNavLink
            disabled={profile?.plan === "Free"}
            label="Plugins"
            link="/plugins"
            icon={IconCameraCog}
          />
        )}
        {plugins?.map((plugin) => (
          <NavLink
            key={plugin.id}
            label={plugin.pluginTitle}
            leftSection={<IconPhotoCog stroke={1.5} />}
          >
            {plugin?.nav?.map((item, idx) => (
              <AibNavLink
                key={plugin.id + ":" + idx}
                label={item.title}
                link={item.url}
              />
            ))}
          </NavLink>
        ))}
      </AppShell.Section>
      <AppShell.Section>
        {authToken ? (
          <AibNavLink
            label="Logout"
            onClick={() => {
              logoutStore();
              mixpanel.reset();
              setLocation("/auth");
            }}
            icon={IconLogout}
          />
        ) : (
          <AibNavLink label="Login" link="/auth" icon={IconKey} />
        )}
      </AppShell.Section>
    </>
  );
}
